/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import {
  XLSX,
  buildCorporateSheet,
  cellTotalLabel,
  cellTotalNumber,
  cellTotalMoney,
} from '../../utils/excelCorporateStyle'
import {
  FaGlobeAmericas,
  FaChartLine,
  FaListOl,
  FaFileExcel,
  FaHistory,
  FaFilter,
  FaTimes,
} from 'react-icons/fa'
import { PiWarningDiamondFill } from 'react-icons/pi'
import {
  Badge,
  PositionBadge,
  RanksGrid,
  StyledTable,
  TableWrapper,
  CoverageHeader,
  TitleSection,
  ActionsGroup,
  TabsContainer,
  TabButton,
  ExportButton,
} from './styles'
import api from '../../services/axios'
import { useMonthFilter } from '../../context/FiltersContext/MonthFilter'
import { useGeralClienteFilter } from '../../context/FiltersContext/ClientsPeriodoFiltro'
import { useGeralFilter } from '../../context/FiltersContext/PeriodoFilter'
import { DashMain } from '../SomarizadorScreen/styles'
import { Skeleton } from '../../components/Skeletron'
import { intervaloDoMes, normalizeDateForComparison, formatDateBr } from '../../constantes'
import { CoberturaAnaliticaResponse, ExportCoverageExcelOptions } from './types'
import { CoveragePotentialTab } from './CoveragePotentialTab'
import { CoverageEvolutionTab } from './CoverageEvolutionTab'
import { CoverageHistoryTab } from './CoverageHistoryTab'
import { ClientAlert } from '../ClientAlert'

export default function RankCoberturaScreen() {
  const {
    distributorId: distIdGeralFilter,
    distributorIds: distIdsGeralFilter,
    startDate: startDateGeralFilter,
    endDate: endDateGeralFilter,
    year: yearGeralFilter,
    month: monthGeralFilter,
    endMonth: endMonthGeralFilter,
    operacao: operacaoGeralFilter,
    marca: marcaGeralFilter,
    categoria: categoriaGeralFilter,
  } = useGeralFilter()

  const {
    distributorId: distIdGeral,
    setDistributor: setDistributorGeral,
    startDate: startDateGeral,
    setStartDate: setStartDateGeral,
    endDate: endDateGeral,
    setEndDate: setEndDateGeral,
    operacao,
    setOperacao,
    uf,
    setUf,
    marca,
    setMarca,
    categoria,
    setCategoria,
    cliente,
    setCliente,
  } = useGeralClienteFilter()

  const {
    month: selectedMonth,
    year: selectedYear,
    distributorId: distIdMonth,
    setDistributor: setDistributorMonth,
  } = useMonthFilter()

  const [activeTab, setActiveTab] = useState<'potencial' | 'evolucao' | 'historico' | 'giro' | 'legado'>('potencial')
  const [loading, setLoading] = useState(true)

  // Dados analíticos (Nova Rota /rank/cobertura-analitica)
  const [analiticoData, setAnaliticoData] = useState<CoberturaAnaliticaResponse | null>(null)

  // Dados legados (Rota clássica /rank/cobertura)
  const [rankPorUF, setRankPorUF] = useState<any[]>([])
  const [rankPorDistribuidor, setRankPorDistribuidor] = useState<any[]>([])
  const [rankPorCidade, setRankPorCidade] = useState<any[]>([])

  // Distribuidor ativo consolidado (prioriza GeralFilterBar e suporta seleção múltipla)
  const activeDistList = useMemo(() => {
    if (distIdsGeralFilter && distIdsGeralFilter.length > 0) return distIdsGeralFilter.map(String)
    if (distIdGeralFilter && distIdGeralFilter !== 'todos') return [String(distIdGeralFilter)]
    if (distIdGeral && distIdGeral !== 'todos') return [String(distIdGeral)]
    if (distIdMonth && distIdMonth !== 'todos') return [String(distIdMonth)]
    return []
  }, [distIdsGeralFilter, distIdGeralFilter, distIdGeral, distIdMonth])

  const activeDistId = useMemo(() => {
    return activeDistList.length === 1
      ? activeDistList[0]
      : activeDistList.length > 1
      ? activeDistList.join(',')
      : undefined
  }, [activeDistList])

  // Cálculo unificado de datas e label de período
  const { effectiveStartDate, effectiveEndDate, effectiveYear, effectiveMonth, periodLabel } = useMemo(() => {
    if (startDateGeralFilter && endDateGeralFilter) {
      const from = normalizeDateForComparison(startDateGeralFilter)
      const to = normalizeDateForComparison(endDateGeralFilter)
      const y = endDateGeralFilter.getFullYear()
      const m = endDateGeralFilter.getMonth()
      const label = `${formatDateBr(startDateGeralFilter)} a ${formatDateBr(endDateGeralFilter)}`
      return {
        effectiveStartDate: from,
        effectiveEndDate: to,
        effectiveYear: y,
        effectiveMonth: m,
        periodLabel: label,
      }
    }

    if (startDateGeralFilter && !endDateGeralFilter) {
      const from = normalizeDateForComparison(startDateGeralFilter)
      const y = startDateGeralFilter.getFullYear()
      const m = startDateGeralFilter.getMonth()
      const label = formatDateBr(startDateGeralFilter)
      return {
        effectiveStartDate: from,
        effectiveEndDate: from,
        effectiveYear: y,
        effectiveMonth: m,
        periodLabel: label,
      }
    }

    if (startDateGeral && endDateGeral) {
      const from = normalizeDateForComparison(startDateGeral)
      const to = normalizeDateForComparison(endDateGeral)
      const y = endDateGeral.getFullYear()
      const m = endDateGeral.getMonth()
      const label = `${formatDateBr(startDateGeral)} a ${formatDateBr(endDateGeral)}`
      return {
        effectiveStartDate: from,
        effectiveEndDate: to,
        effectiveYear: y,
        effectiveMonth: m,
        periodLabel: label,
      }
    }

    if (startDateGeral && !endDateGeral) {
      const from = normalizeDateForComparison(startDateGeral)
      const y = startDateGeral.getFullYear()
      const m = startDateGeral.getMonth()
      const label = formatDateBr(startDateGeral)
      return {
        effectiveStartDate: from,
        effectiveEndDate: from,
        effectiveYear: y,
        effectiveMonth: m,
        periodLabel: label,
      }
    }

    const y = yearGeralFilter || selectedYear || new Date().getFullYear()
    const m =
      monthGeralFilter !== undefined && monthGeralFilter !== null
        ? monthGeralFilter
        : selectedMonth !== undefined && selectedMonth !== null
        ? selectedMonth
        : new Date().getMonth()
    const mEnd =
      endMonthGeralFilter !== undefined && endMonthGeralFilter !== null && endMonthGeralFilter >= m
        ? endMonthGeralFilter
        : m

    const { from } = intervaloDoMes(y, m)
    const { to } = intervaloDoMes(y, mEnd)
    const label =
      m === mEnd
        ? `${String(m + 1).padStart(2, '0')}/${y}`
        : `${String(m + 1).padStart(2, '0')} a ${String(mEnd + 1).padStart(2, '0')}/${y}`

    return {
      effectiveStartDate: from,
      effectiveEndDate: to,
      effectiveYear: y,
      effectiveMonth: m,
      periodLabel: label,
    }
  }, [
    startDateGeralFilter,
    endDateGeralFilter,
    yearGeralFilter,
    monthGeralFilter,
    endMonthGeralFilter,
    startDateGeral,
    endDateGeral,
    selectedYear,
    selectedMonth,
  ])

  const handleClearFilters = () => {
    setStartDateGeral(null)
    setEndDateGeral(null)
    setDistributorGeral(null)
    try {
      if (setDistributorMonth) setDistributorMonth(null)
    } catch (_) {}
    setOperacao('')
    setUf('')
    setCliente('')
    setMarca('')
    setCategoria('')
  }

  const load = async () => {
    if (!effectiveStartDate || !effectiveEndDate) return

    setLoading(true)
    try {
      const payload: any = {
        startDate: effectiveStartDate,
        endDate: effectiveEndDate,
        distId: activeDistId || 'todos',
        distributorIds: activeDistList,
        uf: uf ? [uf] : [],
        regional: (operacaoGeralFilter || operacao) ? [operacaoGeralFilter || operacao] : [],
        marca: (marcaGeralFilter || marca) ? [marcaGeralFilter || marca] : [],
        familias: (categoriaGeralFilter || categoria) ? [categoriaGeralFilter || categoria] : [],
        cliente: cliente || '',
      }

      // Executa em paralelo para velocidade máxima
      const [resAnalitico, resLegado] = await Promise.allSettled([
        api.post('/rank/cobertura-analitica', payload),
        api.post('/rank/cobertura', payload),
      ])

      if (resAnalitico.status === 'fulfilled' && resAnalitico.value.data?.success) {
        setAnaliticoData(resAnalitico.value.data)
      } else {
        console.warn('Não foi possível carregar dados de cobertura analítica')
      }

      if (resLegado.status === 'fulfilled') {
        const data = resLegado.value.data
        const posicionar = (linhas: any[]) =>
          (Array.isArray(linhas) ? linhas : []).map((item, idx) => ({
            ...item,
            cobertura: Number(item.cobertura || 0),
            posicao: idx + 1,
          }))

        setRankPorUF(posicionar(data?.porUf))
        setRankPorDistribuidor(posicionar(data?.porDistribuidor))
        setRankPorCidade(posicionar(data?.porCidade))
      }
    } catch (err) {
      console.error('Erro ao carregar dados de cobertura:', err)
      setRankPorUF([])
      setRankPorDistribuidor([])
      setRankPorCidade([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    effectiveStartDate,
    effectiveEndDate,
    activeDistId,
    uf,
    operacao,
    operacaoGeralFilter,
    marca,
    marcaGeralFilter,
    categoria,
    categoriaGeralFilter,
    cliente,
  ])

  // Soma das coberturas por UF para badge de topo
  const totalPdvs = useMemo(() => {
    if (analiticoData?.nacional?.cobertura_atual) {
      return analiticoData.nacional.cobertura_atual
    }
    return rankPorUF.reduce((acc, item) => acc + Number(item.cobertura || 0), 0)
  }, [analiticoData, rankPorUF])

  // Rankings tradicionais enriquecidos com Potencial e Atingimento, ordenados por atingimento desc
  const rankUfComPotencial = useMemo(() => {
    const list = rankPorUF.map((item) => {
      const ufKey = String(item.nome || item.uf || '').trim().toUpperCase()
      const analitico = analiticoData?.porUf?.find(
        (u) => u.uf.toUpperCase() === ufKey
      )
      const potencial = analitico?.potencial_pdvs ?? 0
      const atingimento = analitico?.atingimento_potencial_pct ?? 0
      return {
        ...item,
        potencial,
        atingimento,
      }
    })

    // Ordena pelo atingimento do potencial (desempate por cobertura)
    list.sort((a, b) => (b.atingimento - a.atingimento) || (b.cobertura - a.cobertura))
    return list.map((item, idx) => ({ ...item, posicao: idx + 1 }))
  }, [rankPorUF, analiticoData])

  const rankDistComPotencial = useMemo(() => {
    const list = rankPorDistribuidor.map((item) => {
      const codKey = String(item.cod).trim()
      const analitico = analiticoData?.porDistribuidor?.find(
        (d) => String(d.cod_dist).trim() === codKey
      )
      const potencial = analitico?.potencial_pdvs ?? 0
      const atingimento = analitico?.atingimento_potencial_pct ?? 0
      return {
        ...item,
        potencial,
        atingimento,
      }
    })

    // Ordena pelo atingimento do potencial (desempate por cobertura)
    list.sort((a, b) => (b.atingimento - a.atingimento) || (b.cobertura - a.cobertura))
    return list.map((item, idx) => ({ ...item, posicao: idx + 1 }))
  }, [rankPorDistribuidor, analiticoData])

  const getPositionColor = (pos: number) => {
    if (pos === 1) return { bg: '#FFD700', text: '#333' }
    if (pos === 2) return { bg: '#C0C0C0', text: '#333' }
    if (pos === 3) return { bg: '#CD7F32', text: '#fff' }
    return { bg: 'rgba(255,255,255,0.1)', text: '#fff' }
  }

  // Exportação consolidada corporativa ou direcionada por visão (Estado vs Distribuidor)
  const handleExportExcel = (options?: ExportCoverageExcelOptions) => {
    if (!analiticoData) return

    const wb = XLSX.utils.book_new()
    const mesAnoStr = periodLabel.replace(/[\/\s]/g, '_')
    const viewMode = options?.viewMode || 'all'
    const tabName = options?.tabName || 'potencial'

    const distList =
      options?.customDists && options.customDists.length > 0
        ? options.customDists
        : analiticoData.porDistribuidor || []

    const ufList =
      options?.customUfs && options.customUfs.length > 0
        ? options.customUfs
        : analiticoData.porUf || []

    // 1. Gerador da planilha de Distribuidores (Potencial & Penetração)
    const getSheetDistribuidores = () => {
      const headersDist = [
        { label: 'Pos', align: 'center' as const },
        { label: 'Código', align: 'center' as const },
        { label: 'Distribuidor', align: 'left' as const },
        { label: 'Regional', align: 'center' as const },
        { label: 'UF Dominante', align: 'center' as const },
        { label: 'UFs Invasão', align: 'left' as const },
        { label: 'Status Território', align: 'center' as const },
        { label: 'Alerta Território', align: 'center' as const },
        { label: 'População Área (IBGE)', align: 'right' as const },
        { label: 'Positivação (Cob. Atual)', align: 'right' as const },
        { label: 'Potencial Estimado (PDVs)', align: 'right' as const },
        { label: 'Gap Oportunidade', align: 'right' as const },
        { label: 'Atingimento Potencial %', align: 'right' as const },
        { label: 'Habitantes / PDV', align: 'right' as const },
        { label: 'Faturamento Total (R$)', align: 'right' as const },
        { label: 'Cob. Anterior', align: 'right' as const },
        { label: 'Base Cadastrada', align: 'right' as const },
        { label: 'Positivação Carteira %', align: 'right' as const },
        { label: 'Ganhos (+)', align: 'right' as const },
        { label: 'Perdidos (-)', align: 'right' as const },
        { label: 'Saldo Líquido', align: 'right' as const },
        { label: 'Variação %', align: 'right' as const },
        { label: 'Total Caixas', align: 'right' as const },
      ]

      const linhasDist = distList.map((d, idx) => [
        idx + 1,
        d.cod_dist,
        d.distribuidor,
        d.regional,
        d.uf_principal || d.uf,
        (d.ufs_invasao || []).map((u: any) => `${u.uf} (${u.cobertura})`).join(', ') || 'Nenhuma',
        d.status_territorio === 'quebra'
          ? 'Quebra de Território'
          : d.status_territorio === 'invasao_pontual'
          ? 'Invasão Pontual'
          : 'Estável',
        d.alerta_territorio || 'Normal',
        typeof d.populacao === 'number' && d.populacao > 0 ? d.populacao : '—',
        d.cobertura_atual,
        d.potencial_pdvs || 0,
        d.gap_pdvs || 0,
        `${(d.atingimento_potencial_pct || 0).toFixed(1)}%`,
        d.hab_por_pdv || '—',
        d.total_valor || 0,
        d.cobertura_anterior,
        d.total_cadastrados || 0,
        `${(d.positivacao_carteira_pct || 0).toFixed(1)}%`,
        d.ganhos,
        d.perdidos,
        d.saldo_liquido,
        `${(d.taxa_evolucao_pct || 0).toFixed(1)}%`,
        d.total_caixas,
      ])

      const totalPop = distList.reduce((acc, d) => acc + (d.populacao || 0), 0)
      const totalCob = distList.reduce((acc, d) => acc + (d.cobertura_atual || 0), 0)
      const totalPot = distList.reduce((acc, d) => acc + (d.potencial_pdvs || 0), 0)
      const totalGap = distList.reduce((acc, d) => acc + (d.gap_pdvs || 0), 0)
      const totalValor = distList.reduce((acc, d) => acc + (d.total_valor || 0), 0)
      const totalAnt = distList.reduce((acc, d) => acc + (d.cobertura_anterior || 0), 0)
      const totalCad = distList.reduce((acc, d) => acc + (d.total_cadastrados || 0), 0)
      const totalGanhos = distList.reduce((acc, d) => acc + (d.ganhos || 0), 0)
      const totalPerdidos = distList.reduce((acc, d) => acc + (d.perdidos || 0), 0)
      const totalSaldo = distList.reduce((acc, d) => acc + (d.saldo_liquido || 0), 0)
      const totalCaixas = distList.reduce((acc, d) => acc + (d.total_caixas || 0), 0)
      const atingMedio = totalPot > 0 ? (totalCob / totalPot) * 100 : 0
      const habPdvMedio = totalCob > 0 ? Math.round(totalPop / totalCob) : 0

      const totalsRow = [
        cellTotalLabel('TOTAIS', 'center'),
        cellTotalLabel('', 'center'),
        cellTotalLabel(`${distList.length} Distribuidores`, 'left'),
        cellTotalLabel('', 'center'),
        cellTotalLabel('', 'center'),
        cellTotalLabel('', 'center'),
        cellTotalLabel('', 'center'),
        cellTotalLabel('', 'center'),
        cellTotalNumber(totalPop),
        cellTotalNumber(totalCob),
        cellTotalNumber(totalPot),
        cellTotalNumber(totalGap),
        cellTotalLabel(`${atingMedio.toFixed(1)}%`, 'right'),
        cellTotalNumber(habPdvMedio),
        cellTotalMoney(totalValor),
        cellTotalNumber(totalAnt),
        cellTotalNumber(totalCad),
        cellTotalLabel(`${totalCad > 0 ? ((totalCob / totalCad) * 100).toFixed(1) : 0}%`, 'right'),
        cellTotalNumber(totalGanhos),
        cellTotalNumber(totalPerdidos),
        cellTotalNumber(totalSaldo),
        cellTotalLabel(`${totalAnt > 0 ? ((totalSaldo / totalAnt) * 100).toFixed(1) : 0}%`, 'right'),
        cellTotalNumber(totalCaixas),
      ]

      return buildCorporateSheet({
        reportTitle: 'Análise de Penetração e Potencial por Distribuidor',
        periodLabel,
        headers: headersDist,
        data: linhasDist,
        totalsRow,
      })
    }

    // 2. Gerador da planilha de Distribuidores (Dinâmica de Positivação / Evolução)
    const getSheetDistribuidoresEvolucao = () => {
      const headersDistEvolucao = [
        { label: 'Pos', align: 'center' as const },
        { label: 'Código', align: 'center' as const },
        { label: 'Distribuidor', align: 'left' as const },
        { label: 'Regional', align: 'center' as const },
        { label: 'UF Dominante', align: 'center' as const },
        { label: 'Cob. Anterior', align: 'right' as const },
        { label: 'Cob. Atual', align: 'right' as const },
        { label: 'Ganhos (+)', align: 'right' as const },
        { label: 'Perdidos (-)', align: 'right' as const },
        { label: 'Saldo Líquido', align: 'right' as const },
        { label: 'Variação %', align: 'right' as const },
        { label: 'Total Caixas', align: 'right' as const },
        { label: 'Total Faturamento (R$)', align: 'right' as const },
      ]

      const linhasDistEvolucao = distList.map((d, idx) => [
        idx + 1,
        d.cod_dist,
        d.distribuidor,
        d.regional,
        d.uf_principal || d.uf,
        d.cobertura_anterior,
        d.cobertura_atual,
        d.ganhos,
        d.perdidos,
        d.saldo_liquido,
        `${(d.taxa_evolucao_pct || 0).toFixed(1)}%`,
        d.total_caixas,
        d.total_valor || 0,
      ])

      const totalAnt = distList.reduce((acc, d) => acc + (d.cobertura_anterior || 0), 0)
      const totalCob = distList.reduce((acc, d) => acc + (d.cobertura_atual || 0), 0)
      const totalGanhos = distList.reduce((acc, d) => acc + (d.ganhos || 0), 0)
      const totalPerdidos = distList.reduce((acc, d) => acc + (d.perdidos || 0), 0)
      const totalSaldo = distList.reduce((acc, d) => acc + (d.saldo_liquido || 0), 0)
      const totalCaixas = distList.reduce((acc, d) => acc + (d.total_caixas || 0), 0)
      const totalValor = distList.reduce((acc, d) => acc + (d.total_valor || 0), 0)

      const totalsRow = [
        cellTotalLabel('TOTAIS', 'center'),
        cellTotalLabel('', 'center'),
        cellTotalLabel(`${distList.length} Distribuidores`, 'left'),
        cellTotalLabel('', 'center'),
        cellTotalLabel('', 'center'),
        cellTotalNumber(totalAnt),
        cellTotalNumber(totalCob),
        cellTotalNumber(totalGanhos),
        cellTotalNumber(totalPerdidos),
        cellTotalNumber(totalSaldo),
        cellTotalLabel(`${totalAnt > 0 ? ((totalSaldo / totalAnt) * 100).toFixed(1) : 0}%`, 'right'),
        cellTotalNumber(totalCaixas),
        cellTotalMoney(totalValor),
      ]

      return buildCorporateSheet({
        reportTitle: 'Dinâmica de Positivação por Distribuidor (Ganhos vs Perdas)',
        periodLabel,
        headers: headersDistEvolucao,
        data: linhasDistEvolucao,
        totalsRow,
      })
    }

    // 3. Gerador da planilha de Potencial por UF
    const getSheetUf = () => {
      const headersUf = [
        { label: 'Pos', align: 'center' as const },
        { label: 'UF', align: 'center' as const },
        { label: 'Estado', align: 'left' as const },
        { label: 'População IBGE', align: 'right' as const },
        { label: 'PDVs Atendidos', align: 'right' as const },
        { label: 'Potencial Estimado (PDVs)', align: 'right' as const },
        { label: 'Gap Oportunidade', align: 'right' as const },
        { label: 'Atingimento Potencial %', align: 'right' as const },
        { label: 'Habitantes / PDV', align: 'right' as const },
        { label: 'Faturamento Total (R$)', align: 'right' as const },
        { label: 'Status Cobertura', align: 'center' as const },
      ]
      const linhasUf = ufList.map((u, idx) => [
        idx + 1,
        u.uf,
        u.estado,
        u.populacao,
        u.cobertura_atual,
        u.potencial_pdvs || 0,
        u.gap_pdvs || 0,
        `${u.atingimento_potencial_pct || 0}%`,
        u.hab_por_pdv || '—',
        u.total_valor,
        u.status_cobertura,
      ])
      return buildCorporateSheet({
        reportTitle: 'Central Analítica de Cobertura & Potencial IBGE',
        periodLabel,
        headers: headersUf,
        data: linhasUf,
      })
    }

    // 4. Gerador da planilha de Dinâmica por UF
    const getSheetUfEvolucao = () => {
      const headersEvolucao = [
        { label: 'UF', align: 'center' as const },
        { label: 'Estado', align: 'left' as const },
        { label: 'Cobertura Anterior', align: 'right' as const },
        { label: 'Cobertura Atual', align: 'right' as const },
        { label: 'Ganhos (+)', align: 'right' as const },
        { label: 'Perdidos (-)', align: 'right' as const },
        { label: 'Mantidos', align: 'right' as const },
        { label: 'Saldo Líquido', align: 'right' as const },
        { label: 'Variação %', align: 'right' as const },
        { label: 'Taxa Churn %', align: 'right' as const },
      ]
      const linhasEvolucao = ufList.map((u) => [
        u.uf,
        u.estado,
        u.cobertura_anterior,
        u.cobertura_atual,
        u.ganhos,
        u.perdidos,
        u.mantidos,
        u.saldo_liquido,
        `${u.taxa_evolucao_pct}%`,
        `${u.taxa_churn_pct}%`,
      ])
      return buildCorporateSheet({
        reportTitle: 'Dinâmica de Positivação (Ganhos vs Perdas)',
        periodLabel,
        headers: headersEvolucao,
        data: linhasEvolucao,
      })
    }

    // Decisão de saída baseada na visão selecionada pelo usuário
    if (viewMode === 'distribuidor') {
      if (tabName === 'evolucao') {
        const ws = getSheetDistribuidoresEvolucao()
        XLSX.utils.book_append_sheet(wb, ws, 'Distribuidores_Evolucao')
        XLSX.writeFile(wb, `Dinamica_Positivacao_Distribuidores_${mesAnoStr}.xlsx`)
      } else {
        const ws = getSheetDistribuidores()
        XLSX.utils.book_append_sheet(wb, ws, 'Distribuidores')
        XLSX.writeFile(wb, `Analise_Cobertura_Distribuidores_${mesAnoStr}.xlsx`)
      }
      return
    }

    if (viewMode === 'uf') {
      if (tabName === 'evolucao') {
        const ws = getSheetUfEvolucao()
        XLSX.utils.book_append_sheet(wb, ws, 'Ganhos vs Perdas')
        XLSX.writeFile(wb, `Dinamica_Positivacao_UFs_${mesAnoStr}.xlsx`)
      } else {
        const ws = getSheetUf()
        XLSX.utils.book_append_sheet(wb, ws, 'Potencial IBGE')
        XLSX.writeFile(wb, `Analise_Cobertura_Por_Estado_${mesAnoStr}.xlsx`)
      }
      return
    }

    // Caso viewMode === 'all' (Exportação Geral pelo botão superior da tela)
    const wsUf = getSheetUf()
    XLSX.utils.book_append_sheet(wb, wsUf, 'Potencial IBGE')

    const wsEvolucao = getSheetUfEvolucao()
    XLSX.utils.book_append_sheet(wb, wsEvolucao, 'Ganhos vs Perdas')

    const wsDist = getSheetDistribuidores()
    XLSX.utils.book_append_sheet(wb, wsDist, 'Distribuidores')

    XLSX.writeFile(wb, `Analise_Cobertura_IBGE_${mesAnoStr}.xlsx`)
  }

  if (loading) {
    return (
      <DashMain>
        <Skeleton />
      </DashMain>
    )
  }

  return (
    <DashMain>
      {/* Cabeçalho Analítico da Tela */}
      <CoverageHeader>
        <TitleSection>
          <h2>
            <FaGlobeAmericas color='#a6c10b' /> Central Analítica de Cobertura & Potencial IBGE
          </h2>
          <p>
            Cruzamento Demográfico Nacional, Penetração e Potencial e Dinâmica de Positivação (Ganhos vs Perdas)
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
            <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}>
              <FaFilter size={10} color='#a6c10b' /> Filtros:
            </span>
            <span style={{ fontSize: 11, background: 'rgba(166, 193, 11, 0.15)', color: '#a6c10b', border: '1px solid rgba(166, 193, 11, 0.3)', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>
              📅 {periodLabel}
            </span>
            {uf && (
              <span style={{ fontSize: 11, background: 'rgba(56, 189, 248, 0.15)', color: '#38bdf8', border: '1px solid rgba(56, 189, 248, 0.3)', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>
                UF: {uf}
              </span>
            )}
              {operacao && (
                <span style={{ fontSize: 11, background: 'rgba(168, 85, 247, 0.15)', color: '#c084fc', border: '1px solid rgba(168, 85, 247, 0.3)', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>
                  Regional: {operacao}
                </span>
              )}
              {activeDistId && activeDistId !== 'todos' && (
                <span style={{ fontSize: 11, background: 'rgba(234, 179, 8, 0.15)', color: '#facc15', border: '1px solid rgba(234, 179, 8, 0.3)', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>
                  Dist: {activeDistId}
                </span>
              )}
              {marca && (
                <span style={{ fontSize: 11, background: 'rgba(249, 115, 22, 0.15)', color: '#fb923c', border: '1px solid rgba(249, 115, 22, 0.3)', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>
                  Marca: {marca}
                </span>
              )}
              {categoria && (
                <span style={{ fontSize: 11, background: 'rgba(236, 72, 153, 0.15)', color: '#f472b6', border: '1px solid rgba(236, 72, 153, 0.3)', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>
                  Família: {categoria}
                </span>
              )}
              {cliente && (
                <span style={{ fontSize: 11, background: 'rgba(52, 211, 153, 0.15)', color: '#34d399', border: '1px solid rgba(52, 211, 153, 0.3)', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>
                  Cliente: {cliente}
                </span>
              )}
              <button
                type='button'
                onClick={handleClearFilters}
                style={{
                  fontSize: 10,
                  background: 'rgba(239, 68, 68, 0.15)',
                  color: '#f87171',
                  border: '1px solid rgba(239, 68, 68, 0.3)',
                  padding: '2px 6px',
                  borderRadius: 4,
                  cursor: 'pointer',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                }}
                title='Limpar todos os filtros'
              >
                <FaTimes size={9} /> Limpar
              </button>
            </div>
        </TitleSection>

        <ActionsGroup>
          <ExportButton
            onClick={() => handleExportExcel({ viewMode: 'all' })}
            title='Baixar planilha completa com dados do IBGE'
          >
            <FaFileExcel />
            Exportar Relatório Excel
          </ExportButton>

          <Badge>
            Total de PDVs Atendidos
            <p style={{ fontSize: 24, textAlign: 'center', margin: '5px 0 0 0', fontWeight: 'bold', color: '#ffffff' }}>
              {totalPdvs.toLocaleString('pt-BR')}
            </p>
          </Badge>
        </ActionsGroup>
      </CoverageHeader>

      {/* Seletor de Visões / Abas */}
      <TabsContainer>
        <TabButton
          $active={activeTab === 'potencial'}
          onClick={() => setActiveTab('potencial')}
        >
          <FaGlobeAmericas />
          Potencial IBGE & Penetração
        </TabButton>

        <TabButton
          $active={activeTab === 'evolucao'}
          onClick={() => setActiveTab('evolucao')}
        >
          <FaChartLine />
          Dinâmica de Positivação (Ganhos vs Perdas)
        </TabButton>

        <TabButton
          $active={activeTab === 'historico'}
          onClick={() => setActiveTab('historico')}
        >
          <FaHistory />
          Histórico de PDVs & Churn
        </TabButton>

        <TabButton
          $active={activeTab === 'giro'}
          onClick={() => setActiveTab('giro')}
        >
          <PiWarningDiamondFill />
          Acompanhamento de Giro
        </TabButton>

        <TabButton
          $active={activeTab === 'legado'}
          onClick={() => setActiveTab('legado')}
        >
          <FaListOl />
          Rankings Tradicionais
        </TabButton>
      </TabsContainer>

      {/* Renderização Condicional da Visão Selecionada */}
      {activeTab === 'potencial' && analiticoData && (
        <CoveragePotentialTab
          data={analiticoData}
          onExportExcel={handleExportExcel}
          selectedDistributorIdFilter={activeDistId}
        />
      )}

      {activeTab === 'evolucao' && analiticoData && (
        <CoverageEvolutionTab data={analiticoData} onExportExcel={handleExportExcel} />
      )}

      {activeTab === 'historico' && (
        <CoverageHistoryTab
          distributorId={activeDistId}
          anoAtualPadrao={effectiveYear}
          mesAtualPadrao={effectiveMonth}
        />
      )}

      {activeTab === 'giro' && (
        <ClientAlert hideFamilyCharts={true} />
      )}

      {activeTab === 'legado' && (
        <RanksGrid>
          <TableWrapper>
            <h3 style={{ color: '#a6c10b', marginBottom: '16px' }}>Rank por UF (Ordenado por Atingimento)</h3>
            <StyledTable>
              <thead>
                <tr>
                  <th style={{ width: '50px' }}>Pos</th>
                  <th>UF</th>
                  <th style={{ textAlign: 'right' }}>Cobertura</th>
                  <th style={{ textAlign: 'right' }}>Potencial</th>
                  <th style={{ textAlign: 'right' }}>Atingimento</th>
                </tr>
              </thead>
              <tbody>
                {rankUfComPotencial.map((item) => (
                  <tr key={item.nome || item.uf}>
                    <td>
                      <PositionBadge
                        bgColor={getPositionColor(item.posicao).bg}
                        textColor={getPositionColor(item.posicao).text}
                      >
                        {item.posicao}
                      </PositionBadge>
                    </td>
                    <td style={{ fontWeight: 'bold' }}>{item.nome || item.uf}</td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                      {Number(item.cobertura || 0).toLocaleString('pt-BR')}
                    </td>
                    <td style={{ textAlign: 'right', color: '#94a3b8' }}>
                      {item.potencial > 0 ? item.potencial.toLocaleString('pt-BR') : '—'}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <span
                        style={{
                          fontWeight: 'bold',
                          color:
                            item.atingimento >= 100
                              ? '#10b981'
                              : item.atingimento >= 70
                              ? '#a6c10b'
                              : item.atingimento >= 40
                              ? '#f59e0b'
                              : '#ef4444',
                        }}
                      >
                        {item.atingimento > 0 ? `${item.atingimento}%` : '—'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>
          </TableWrapper>

          <TableWrapper>
            <h3 style={{ color: '#a6c10b', marginBottom: '16px' }}>Rank por Distribuidor (Ordenado por Atingimento)</h3>
            <StyledTable>
              <thead>
                <tr>
                  <th style={{ width: '50px' }}>Pos</th>
                  <th>Cód.</th>
                  <th>Distribuidor</th>
                  <th style={{ textAlign: 'right' }}>Cobertura</th>
                  <th style={{ textAlign: 'right' }}>Potencial</th>
                  <th style={{ textAlign: 'right' }}>Atingimento</th>
                </tr>
              </thead>
              <tbody>
                {rankDistComPotencial.map((item) => (
                  <tr key={item.cod}>
                    <td>
                      <PositionBadge
                        bgColor={getPositionColor(item.posicao).bg}
                        textColor={getPositionColor(item.posicao).text}
                      >
                        {item.posicao}
                      </PositionBadge>
                    </td>
                    <td style={{ color: '#94a3b8' }}>{item.cod}</td>
                    <td>{item.nome}</td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                      {Number(item.cobertura || 0).toLocaleString('pt-BR')}
                    </td>
                    <td style={{ textAlign: 'right', color: '#94a3b8' }}>
                      {item.potencial > 0 ? item.potencial.toLocaleString('pt-BR') : '—'}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <span
                        style={{
                          fontWeight: 'bold',
                          color:
                            item.atingimento >= 100
                              ? '#10b981'
                              : item.atingimento >= 70
                              ? '#a6c10b'
                              : item.atingimento >= 40
                              ? '#f59e0b'
                              : '#ef4444',
                        }}
                      >
                        {item.atingimento > 0 ? `${item.atingimento}%` : '—'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>
          </TableWrapper>

          <TableWrapper>
            <h3 style={{ color: '#a6c10b', marginBottom: '16px' }}>Rank por Cidade (Top 20)</h3>
            <StyledTable>
              <thead>
                <tr>
                  <th style={{ width: '50px' }}>Pos</th>
                  <th>Cidade</th>
                  <th style={{ width: '60px' }}>UF</th>
                  <th style={{ textAlign: 'right' }}>Cobertura</th>
                </tr>
              </thead>
              <tbody>
                {rankPorCidade.slice(0, 20).map((item) => (
                  <tr key={`${item.nome}-${item.uf}-${item.posicao}`}>
                    <td>
                      <PositionBadge
                        bgColor={getPositionColor(item.posicao).bg}
                        textColor={getPositionColor(item.posicao).text}
                      >
                        {item.posicao}
                      </PositionBadge>
                    </td>
                    <td>{item.cidade || item.nome}</td>
                    <td style={{ color: '#a6c10b', fontWeight: 'bold' }}>{item.uf}</td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
                      {Number(item.cobertura || 0).toLocaleString('pt-BR')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>
          </TableWrapper>
        </RanksGrid>
      )}
    </DashMain>
  )
}
